var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.744 12.585L8.851 30.478h16.317c.87 0 1.576-.706 1.576-1.576V12.585zm-1.61-3.087H4.392c-.87 0-1.576.706-1.576 1.576v17.828c0 .794.589 1.452 1.354 1.56L25.134 9.498zM28.944 16.575l6.769-5.58a.9.9 0 011.471.694v17.914a.9.9 0 01-1.485.682l-6.662-5.718-.093-7.992z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.77 6.747l1.686 1.686L6.181 35.708l-1.686-1.685z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOff);
export default __webpack_public_path__ + "static/media/video-off.aaa4c7453e5ef692321544cd4abaa62d.svg";
export { ForwardRef as ReactComponent };